import React from "react";

// Shared loading state so every page waits on the same spinner instead of
// each rolling its own, and so a page never flashes an empty version of
// itself before its data arrives.
function LoadingScreen({ message = "Loading...", fullScreen = true }) {
  return (
    <div className={fullScreen ? "min-h-screen flex items-center justify-center bg-surface-subtle" : "flex items-center justify-center py-24"}>
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-hairline border-t-blue-600 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-ink-muted">{message}</p>
      </div>
    </div>
  );
}

export default LoadingScreen;
